import { render, staticRenderFns } from "./PendingPaymentsView.vue?vue&type=template&id=b7bad060&"
import script from "./PendingPaymentsView.vue?vue&type=script&lang=js&"
export * from "./PendingPaymentsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports